import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PageContentBox, Box } from '../../components/element';
import { PageTitleBox } from '../../components/menu';
import { useTranslation } from 'react-i18next';
import { PageNavBar } from '../../components/page';
import { GenericSelect, IconOptionItem } from '../../components/select';
import arrayModelIcon from '../../images/array.png';
import { setArrayModel } from '../../actions';
import {
  getQueryStringValues,
  ChangeQueryString,
  validatePageQueryString,
} from '../../utils/withPath';
import { getArrayModelListAction, toggleSideMenu } from '../../actions';
import {
  PRODUCT_ID_BAAS,
  PRODUCT_ID_OAAS,
  MODEL_ALLETRAMP,
  PRODUCT_ID_FILE,
  PRODUCT_ID_PCBE,
  SIMPLIVITY_OPT_325GEN,
  HPE_SIMPLIVITY,
  NEW_ESXI_CLUSTER,
  MODEL_ALLETRAMPX10000,
  PRODUCT_ID_SDS,
  PRODUCT_ID_ALLETRAB10K,
  MODEL_LIST_PCBE,
  CABLETRAY_OPT_NO,
} from '../../constants';
import { PageOptSelector, StoragePurchaseSelector } from '../selectModelPage';

export default function SelectModelPage(props) {
  const { t } = useTranslation();

  const modelSelectorLabels = useMemo(
    () => ({
      [PRODUCT_ID_BAAS]: t('selectArrayModelDescBaas'),
      [PRODUCT_ID_OAAS]: t('selectArrayModelDescBaas'),
      [PRODUCT_ID_FILE]: t('selectArrayModelDescBaas'),
      [PRODUCT_ID_PCBE]: t('selectArrayModelDescBaas'),
      [PRODUCT_ID_SDS]: t('selectArrayModelDescBaas'),
      [PRODUCT_ID_ALLETRAB10K]: t('selectArrayModelDescAlletraB10K'),
    }),
    [t],
  );

  const getModelSelectorLabel = (props) => {
    const { productId } = props;
    let label = modelSelectorLabels[productId];
    if (label === undefined) {
      label = t('selectArrayModelDesc');
    }
    return label;
  };

  const _history = props.history;
  const _location = props.location;
  validatePageQueryString(_location, _history);

  const dispatch = useDispatch();
  const queryStringValues = getQueryStringValues(props.location);
  const productName = queryStringValues['product'];

  const [pageProps] = useState(props.pageProps);

  const [modelValue, setModelValue] = useState('');
  const [selectModelErrMsg, setSelectModelErrMsg] = useState('');
  const [options, setOptions] = useState([]);
  const [productForOptSelector, setProductForOptSelector] =
    useState(productName);

  const history = props.history;
  const pageName = pageProps.pageName;
  let model = queryStringValues['model'];
  const modelList = useSelector((props) => props.techDocReducer['modelList']);
  const storagePurchaseOpt = queryStringValues['storagepurchaseopt'];
  const connectOpt = queryStringValues['connectopt'];
  const configureOpt = queryStringValues['configureopt'];
  const opt = queryStringValues['opt'];
  const simplivitymodel = queryStringValues['simplivitymodel'];
  const hpeAlletraDHCImodel = queryStringValues['hpeAlletraDHCImodel'];
  const greenlakePlatformOpt = queryStringValues['greenlakeplatform'];
  const hypervisorOpt = queryStringValues['hypervisoropt'];
  const [SelectPurchaseErrMsg, setSelectPurchaseErrMsg] = useState('');
  const [SelectConnectOptErrMsg, setConnectOptErrMsg] = useState('');
  const [SelectConfigureOptErrMsg, setConfigureOptErrMsg] = useState('');
  const [SelectOptErrMsg, setOptErrMsg] = useState('');
  const [SelectSimplivityModelErrMsg, setSimplivityModelErrMsg] = useState('');
  const [SelectHpeAlletraDHCIModelErrMsg, setHpeAlletraDHCIModelErrMsg] =
    useState('');
  const [SelectGreenlakePlatformErrMsg, setGreenlakePlatformErrMsg] =
    useState('');
  const [SelectHypervisorErrMsg, setHypervisorErrMsg] = useState('');
  const pcbeFlashModelIndexes = [3, 4];
  const selectModel =
    productName === PRODUCT_ID_OAAS ? MODEL_ALLETRAMPX10000 : MODEL_ALLETRAMP;
  useEffect(() => {
    if (typeof modelList === 'undefined') {
      getArrayModelListAction(productName, dispatch);
      return;
    }

    if (
      (productName === PRODUCT_ID_FILE || productName === PRODUCT_ID_PCBE) &&
      storagePurchaseOpt === ''
    ) {
      setSelectPurchaseErrMsg(t('errorSelectPurchase'));
    } else {
      setSelectPurchaseErrMsg('');
    }
    if (
      (productName === PRODUCT_ID_ALLETRAB10K ||
        productName === PRODUCT_ID_OAAS) &&
      connectOpt === ''
    ) {
      setConnectOptErrMsg(t('errorSelectConnectionMethod'));
    } else {
      setConnectOptErrMsg('');
    }
    if (productName === PRODUCT_ID_ALLETRAB10K && configureOpt === '') {
      setConfigureOptErrMsg(t('errorSelectConfigureMethod'));
    } else {
      setConfigureOptErrMsg('');
    }
    if (productName === PRODUCT_ID_ALLETRAB10K && opt === '') {
      setOptErrMsg(t('errorSelectInstallationType'));
    } else {
      setOptErrMsg('');
    }
    if (productName === PRODUCT_ID_ALLETRAB10K && greenlakePlatformOpt === '') {
      setGreenlakePlatformErrMsg(t('errorSelectGreenlakePlatform'));
    } else {
      setGreenlakePlatformErrMsg('');
    }
    if (productName === PRODUCT_ID_PCBE && simplivitymodel === '') {
      setSimplivityModelErrMsg(t('errorSelectSimplivityModel'));
    } else {
      setSimplivityModelErrMsg('');
    }
    if (productName === PRODUCT_ID_PCBE && hpeAlletraDHCImodel === '') {
      setHpeAlletraDHCIModelErrMsg(t('errorSelectHpeAlletraDHCIModel'));
    } else {
      setHpeAlletraDHCIModelErrMsg('');
    }
    if (productName === PRODUCT_ID_PCBE && hypervisorOpt === '') {
      setHypervisorErrMsg(t('errorSelectHypervisor'));
    } else {
      setHypervisorErrMsg('');
    }
    if (modelList && Object.keys(modelList).length > 0) {
      if (
        storagePurchaseOpt === 'owned' &&
        Object.keys(modelList).indexOf(selectModel) !== -1 &&
        productName !== PRODUCT_ID_PCBE
      ) {
        const alletraIndex = Object.keys(modelList).indexOf(selectModel);
        const modelObj = Object.keys(modelList).splice(alletraIndex, 3);
        setOptions(modelObj);
      } else if (productName === PRODUCT_ID_PCBE) {
        if (storagePurchaseOpt === 'owned') {
          setOptions(
            Object.keys(modelList).filter(
              (value, index) => ![3, 4].includes(index),
            ),
          );
        } else {
          setOptions(
            Object.keys(modelList).filter((value, index) =>
              [3, 4].includes(index),
            ),
          );
        }
      } else {
        const alletraIndex = Object.keys(modelList).indexOf(selectModel);
        const modelObj = Object.keys(modelList).filter(
          (ele, idx) => idx !== alletraIndex,
        );
        setOptions(modelObj);
      }
      let modelErrMsg = selectModelErrMsg;
      let modelName = model;
      if (typeof model !== 'undefined') {
        if (Object.keys(modelList).indexOf(model) === -1) {
          modelName = '';
          modelErrMsg = t('errorSelectModel');
        } else {
          const subProductId = modelList[model].productId;
          setProductForOptSelector(subProductId);
        }
      } else {
        modelName = '';
        modelErrMsg = '';
      }
      setSelectModelErrMsg(modelErrMsg);
      setModelValue(modelName);
    } else {
      getArrayModelListAction(productName, dispatch);
    }
  }, [
    modelList,
    selectModel,
    productName,
    history,
    model,
    selectModelErrMsg,
    storagePurchaseOpt,
    connectOpt,
    configureOpt,
    opt,
    simplivitymodel,
    hpeAlletraDHCImodel,
    greenlakePlatformOpt,
    hypervisorOpt,
    dispatch,
    t,
  ]);

  const onModelSearch = (searchText) => {
    const regexp = new RegExp(searchText, 'i');
    let modelObj = Object.keys(modelList);
    if (
      storagePurchaseOpt === 'owned' &&
      Object.keys(modelList).indexOf(selectModel) !== -1 &&
      productName !== PRODUCT_ID_PCBE
    ) {
      const alletraIndex = Object.keys(modelList).indexOf(selectModel);
      modelObj = Object.keys(modelList).splice(alletraIndex, 1);
      setOptions(modelObj.filter((o) => o.match(regexp)));
    } else if (productName === PRODUCT_ID_PCBE) {
      if (storagePurchaseOpt === 'owned') {
        setOptions(
          Object.keys(modelList).filter(
            (value, index) => !pcbeFlashModelIndexes.includes(index),
          ),
        );
      } else {
        setOptions(
          Object.keys(modelList).filter((value, index) =>
            pcbeFlashModelIndexes.includes(index),
          ),
        );
      }
    } else {
      const alletraIndex = Object.keys(modelList).indexOf(selectModel);
      modelObj = Object.keys(modelList).filter(
        (ele, idx) => idx !== alletraIndex,
      );
      setOptions(modelObj.filter((o) => o.match(regexp)));
    }
  };

  const onModelChange = (event) => {
    const value = event.value;
    setModelValue(value);
    if (value === selectModel) {
      ChangeQueryString(
        { model: value, storagepurchaseopt: storagePurchaseOpt },
        props.location,
        props.history,
      );
    } else if (MODEL_LIST_PCBE.includes(value)) {
      ChangeQueryString(
        {
          model: value,
          storagepurchaseopt: storagePurchaseOpt,
          simplivitymodel: '',
          hpeAlletraDHCImodel: NEW_ESXI_CLUSTER,
        },
        props.location,
        props.history,
      );
    } else if (value === HPE_SIMPLIVITY) {
      ChangeQueryString(
        {
          model: value,
          storagepurchaseopt: storagePurchaseOpt,
          opt: '',
          simplivitymodel: SIMPLIVITY_OPT_325GEN,
        },
        props.location,
        props.history,
      );
    } else if (productName === PRODUCT_ID_ALLETRAB10K) {
      ChangeQueryString(
        { model: value, cabletray: CABLETRAY_OPT_NO },
        props.location,
        props.history,
      );
    } else {
      ChangeQueryString({ model: value }, props.location, props.history);
    }
    setArrayModel(value);
  };

  const onModelSelectorClose = () => {
    if (modelList && Object.keys(modelList).length > 0) {
      if (
        storagePurchaseOpt === 'owned' &&
        Object.keys(modelList).indexOf(selectModel) !== -1 &&
        productName !== PRODUCT_ID_PCBE
      ) {
        const alletraIndex = Object.keys(modelList).indexOf(selectModel);
        const modelObj = Object.keys(modelList).splice(alletraIndex, 1);
        setOptions(modelObj);
      } else if (productName === PRODUCT_ID_PCBE) {
        if (storagePurchaseOpt === 'owned') {
          setOptions(
            Object.keys(modelList).filter(
              (value, index) => !pcbeFlashModelIndexes.includes(index),
            ),
          );
        } else {
          setOptions(
            Object.keys(modelList).filter((value, index) =>
              pcbeFlashModelIndexes.includes(index),
            ),
          );
        }
      } else {
        const alletraIndex = Object.keys(modelList).indexOf(selectModel);
        const modelObj = Object.keys(modelList).filter(
          (ele, idx) => idx !== alletraIndex,
        );
        setOptions(modelObj);
      }
    }
  };
  const modelSelectorLabel = getModelSelectorLabel({ productId: productName });
  return (
    <PageContentBox fill={true}>
      <Box direction="column" className="content">
        <PageTitleBox
          responsive={props.responsive}
          title={t(pageName)}
          category={t('gettingStarted')}
          onResponsiveMenuIconClick={() => toggleSideMenu(true, dispatch)}
        />
        {(productName === PRODUCT_ID_OAAS ||
          productName === PRODUCT_ID_FILE ||
          productName === PRODUCT_ID_PCBE) && (
          <StoragePurchaseSelector
            history={_history}
            location={_location}
            product={productName}
            PurchaseErrMsg={SelectPurchaseErrMsg}
          />
        )}
        <Box
          width="medium"
          data-test-id="select-array-model"
          className=" marginBottom6"
        >
          <GenericSelect
            id="model-selector"
            label={modelSelectorLabel}
            value={modelValue}
            errorMessage={selectModelErrMsg}
            onChange={onModelChange}
            onSearch={onModelSearch}
            onClose={onModelSelectorClose}
            options={options}
          >
            {(option) => {
              return (
                <IconOptionItem
                  option={option}
                  iconClass="arrayModelIcon"
                  iconSrc={arrayModelIcon}
                  iconAlt="Array Model Icon"
                />
              );
            }}
          </GenericSelect>
        </Box>
        <PageOptSelector
          history={_history}
          location={_location}
          product={productForOptSelector}
          installationErrMsg={SelectOptErrMsg}
          connectionErrMsg={SelectConnectOptErrMsg}
          configureErrMsg={SelectConfigureOptErrMsg}
          simplivityModelErrMsg={SelectSimplivityModelErrMsg}
          hpeAlletraDHCIModelErrMsg={SelectHpeAlletraDHCIModelErrMsg}
          greenlakePlatformErrMsg={SelectGreenlakePlatformErrMsg}
          hypervisorErrMsg={SelectHypervisorErrMsg}
        />
      </Box>
      <PageNavBar
        nextPage={pageProps.nextPage}
        prevPage="/"
        history={props.history}
        pageName={pageName}
      />
    </PageContentBox>
  );
}
